/** @format */

import React, { FC } from 'react'
import { _$ } from '@king-design/react'
import styled from 'styled-components'
import MonitorCrumb from 'src/components/MonitorCrumb'
import AlarmSilences from 'src/containers/MonitorAlarmSilences'
interface Props {
  className?: string
}

const MonitorAlarmSilences: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: _$('告警服务') }, { title: _$('告警屏蔽') }]} />
      <AlarmSilences />
    </div>
  )
}

export default styled(MonitorAlarmSilences)``
